import { CHAIN_IDS } from 'utils/wagmi'
import Liquidity from '../views/Pool'

const LiquidityPage = () => <Liquidity />

LiquidityPage.chains = CHAIN_IDS

export default LiquidityPage
